function initPage9(vm, FileTemplateService, self) {
	//load benRelationshipItems
	FileTemplateService.query({uri:'getBenRelationshipItems',flgStartUp:true}, function(result){
		vm.benStartUpRelationshipItems = result;
	});
//	vm.checkbenStartUpList = true;
//	vm.checkTotalbenStartUpList = function(){				
////		var totalbenStartUpList = 0;
////		vm.checkAllBen  = false;
//		for ( var benStartUp in vm.proposal.benStartUpList) {
////			if(vm.proposal.benStartUpList[ben].customer.idNum != null && vm.proposal.benStartUpList[ben].customer.idNum != '') {
////				totalbenStartUpList +=  Number(vm.proposal.benStartUpList[ben].percent);
////				vm.checkAllBen = true;
////			}
//			if(vm.proposal.benStartUpList[benStartUp].relationshipCode == null){
//				vm.proposal.benStartUpList[benStartUp].relationshipCode = '';
//			}
//		}
////		if(vm.checkAllBen && totalbenStartUpList == 100){
//			vm.checkbenStartUpList = false;
////		}else{
////			vm.checkbenStartUpList = true;
////		}
//	}	
	//config birthdate
	vm.defaultPage9 = function(){
		vm.dob =[false];
		vm.openDatePickerPage9 = function(index) {	
			vm.dob[index] = true;
		};		
//		vm.checkTotalbenStartUpList();
	};
	
	vm.defaultPage9();
	vm.requiedBenStartUpRelationshipCode = [];
	vm.benCMNDPage9 = function(index){		
		if(vm.proposal.benStartUpList[index].customer.idNum != null && vm.proposal.benStartUpList[index].customer.idNum != '') {
			vm.requiedBenStartUpRelationshipCode[index] = true;
		}else{
			vm.requiedBenStartUpRelationshipCode[index] = false;
		}		
	}
	vm.benAgePage9 = function(index){
		vm.checkAgeBenStartUp = false;
		if(vm.proposal.benStartUpList[index].customer.dob != null && vm.proposal.benStartUpList[index].customer.dob != '' && vm.proposal.benStartUpList[index].customer.dob != undefined) {
			FileTemplateService.post({
				uri : 'check-age-ben-start-up'
			}, vm.proposal, function(result) {
				if(result.checkAgeBenStartUp == false){
					self.clearMessage();
					self.addAlert('Quá tuổi chỉ định QL quà tặng khởi nghiệp.');
					vm.checkAgeBenStartUp = true;
    			}else{
    				vm.checkAgeBenStartUp = false;
    			}
			});
		}	
	}
	
	vm.validatePage9 = function(){
		var flag = false;		
		flag = vm.validateAllRequired(flag);	
		if(vm.checkAgeBenStartUp){
			self.clearMessage();
			self.addAlert('Quá tuổi chỉ định QL quà tặng khởi nghiệp.');
			flag = true;
		}			
		//remove text if idnum = null or ''
		for ( var index in vm.proposal.benStartUpList) {			
			if(vm.proposal.benStartUpList[index].customer.idNum == null || vm.proposal.benStartUpList[index].customer.idNum == ''
				|| vm.proposal.benStartUpList[index].customer.dob == null || vm.proposal.benStartUpList[index].customer.dob == '') {
				vm.proposal.benStartUpList[index].relationshipCode = '';
				vm.proposal.benStartUpList[index].customer = {};
				vm.proposal.benStartUpList[index].customer.lastName = '';
				vm.proposal.benStartUpList[index].customer.firstName = '';
				vm.proposal.benStartUpList[index].customer.gender = null;
				vm.proposal.benStartUpList[index].customer.dob = '';
				vm.proposal.benStartUpList[index].customer.nationality = 'VN';
				vm.proposal.benStartUpList[index].customer.street = ''
				vm.proposal.benStartUpList[index].customer.idNum ==null;
			}
		}
		return flag;
	}
}